let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("6wr18"), load("k28dP"), load("7EorR"), load("ffEVr"), load("kiDFE")]).then(() => parcelRequire('9YlvD'));